<app-page-hero-redesign
    [title]="'News & Articles'"
    [backgroundImage]="'/assets/img/redesign/solutions/hero-page-bg.png'"
    [breadcrumbs]="[
        { label: 'Home', link: '/' },
        { label: 'News & Articles' }
    ]">
</app-page-hero-redesign>
<main class="news-single">

    <div class="container-redesign">

        <!-- ==========================================
            Hero Image
        ========================================== -->

        <div class="news-single__hero">

            <img
                [src]="heroImage"
                [alt]="heroAlt">

        </div>

        <!-- ==========================================
            Article Meta
        ========================================== -->

        <div class="news-single__meta">

            <span class="news-single__meta-item">

                <img
                    src="/assets/img/redesign/news/calendar.svg"
                    alt="">

                {{ publishDate }}

            </span>


            <span class="news-single__meta-item">

                <img
                    src="/assets/img/redesign/news/comments.svg"
                    alt="">

                Comments ({{ comments }})

            </span>

            <span class="news-single__meta-item">

                <img
                    src="/assets/img/redesign/news/time.svg"
                    alt="">

                {{ readingTime }}

            </span>

        </div>

        <!-- ==========================================
            Title
        ========================================== -->

        <h1 class="news-single__title">

            {{ title }}

        </h1>

        <!-- ==========================================
            Introduction
        ========================================== -->

        <div class="news-single__introduction">

            <p
                *ngFor="let paragraph of introduction; trackBy: trackByIndex"
                class="news-single__paragraph">

                {{ paragraph }}

            </p>

        </div>

        <div class="video-wrapper" style="aspect-ratio: 16 / 9; width: 100%;">
                <iframe 
                    style="width: 100%; height: 100%;"
                    src="https://www.youtube.com/embed/1oNU13J3N20?si=77_knbDCP8qeLM70&autoplay=1&mute=1"
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerpolicy="strict-origin-when-cross-origin" 
                    allowfullscreen>
                </iframe>
            </div>
            
        <!-- ==========================================
            Quote
        ========================================== -->

        <blockquote class="news-single__quote">

            <p class="news-single__quote-text">

                {{ quote }}

            </p>

            <footer class="news-single__quote-author">

                — {{ quoteAuthor }}

            </footer>

            <img
                src="/assets/img/redesign/news/quote.svg"
                alt=""
                class="news-single__quote-icon">

        </blockquote>

        <!-- ==========================================
            Features
        ========================================== -->

        <section class="news-single__features">

            <div class="news-single__features-content">

                <h2 class="news-single__subtitle">

                    {{ featuresTitle }}

                </h2>

                <ul class="news-single__feature-list">

                    <li
                        *ngFor="let feature of features; trackBy: trackByIndex"
                        class="news-single__feature-item">

                        <img
                            src="/assets/img/redesign/news/check.svg"
                            alt="">

                        <span>

                            {{ feature.text }}

                        </span>

                    </li>

                </ul>

            </div>

            <div class="news-single__features-image">

                <img
                    [src]="featureImage"
                    [alt]="featureImageAlt">

            </div>

        </section>

        <!-- ==========================================
            Gallery
        ========================================== -->

        <section class="news-single__gallery">

            <img
                *ngFor="let image of gallery; trackBy: trackByIndex"
                [src]="image.image"
                [alt]="image.alt"
                class="news-single__gallery-image">

        </section>

        <!-- ==========================================
            Conclusion
        ========================================== -->

        <div class="news-single__conclusion">

            <p class="news-single__paragraph">

                {{ conclusion }}

            </p>

        </div>

        <!-- ==========================================
            Footer
        ========================================== -->

        <div class="news-single__footer">

            <div class="news-single__tags">

                <span class="news-single__label">

                    Tags:

                </span>

                <a
                    *ngFor="let tag of tags; trackBy: trackByTag"
                    href="#"
                    class="news-single__tag">

                    {{ tag.label }}

                </a>

            </div>

            <div class="news-single__share">

                <span class="news-single__label">

                    Share:

                </span>

                <a
                    [href]="shareFacebook"
                    target="_blank">

                    <img
                        src="/assets/img/redesign/footer/facebook.svg"
                        alt="Facebook">

                </a>

                <a
                    [href]="shareLinkedin"
                    target="_blank">

                    <img
                        src="/assets/img/redesign/footer/linkedin.svg"
                        alt="LinkedIn">

                </a>

            </div>

        </div>

    </div>

</main>